import { OfficeBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/officeBlock/officeBlock.layout'
import * as React from 'react'
import { Updater, IOWidget, fromJSX } from 'widgets-for-react'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'

export type officeBlockProps = {
  block_index: number
  mainTitle?: string
  subTitle: string
  introduction?: string
  title?: string
  maplink?: Link
  address?: string
  postalAddress?: string
  country?: string
  postalCountry?: string
  email?: Array<string>
  telephone?: Array<string>
  fax?: Array<string>
  street?: string
  postcode?: string
  city?: string
  postalStreet?: string
  postalCode?: string
  postalCity?: string
  body?: string
  website?: Link
}

export function officeBlock(
  props: officeBlockProps
): IOWidget<
  CMSState,
  Updater<CMSState>
> {
  return (cmsState) => {
    return fromJSX(() => {
        const {
          block_index,
          mainTitle,
          subTitle,
          introduction,
          title,
          maplink,
          address,
          postalAddress,
          country,
          postalCountry,
          email,
          telephone,
          fax,
          street,
          postcode,
          city,
          postalStreet,
          postalCode,
          postalCity,
          body,
          website
        } = props
        return (
          <OfficeBlockLayout
            nested={false}
            id={block_index.toString()}
            title={mainTitle}
            intro={introduction}
            body={body}
            address={{
              title: title,
              visiting:
                address || street || postcode || city || country || maplink
                  ? {
                      address,
                      street,
                      code: postcode,
                      city,
                      country,
                      mapLink:
                        maplink && maplink.title && maplink.url
                          ? {
                              ...maplink,
                              isExternal: maplink.is_link_external || true
                            }
                          : undefined
                    }
                  : undefined,
              postal:
                postalAddress || postalStreet || postalCode || postalCity || postalCountry
                  ? {
                      address: postalAddress,
                      street: postalStreet,
                      code: postalCode,
                      city: postalCity,
                      country: postalCountry
                    }
                  : undefined
            }}
            contact={{
              title: subTitle,
              email,
              telephone,
              fax,
              website:
                website && website.title && website.url
                  ? {
                      ...website,
                      isExternal: website.is_link_external || true
                    }
                  : undefined
            }}
          />
        )
      }
    )
  }
}
